export default "__VITE_ASSET__DW_RPAmr__"